import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import QueueMessageSummaryRow from "../domain/QueueMessageSummaryRow";
import QueueMessage from "../domain/QueueMessage";

export type QueueMessageStatus = "ready" | "scheduled";

export interface QueueMessageFilter {
    type?: string;
    status?: QueueMessageStatus;
    hasError?: boolean;
}

class QueueService {

    readonly basePath = "/queues";

    public getSummary(): Promise<QueueMessageSummaryRow[]> {
        return Axios.get(`${this.basePath}/summary`)
            .then(value => value.data.map((item: any) => QueueMessageSummaryRow.fromPOJO(item)));
    }

    public getMessages(queryOptions: QueryOptions, filter: QueueMessageFilter): Promise<PagedResult<QueueMessage>> {
        const params = new URLSearchParams(queryOptions.toQueryParams());

        if (filter.type) {
            params.set("type", filter.type);
        }

        if (filter.status) {
            params.set("status", filter.status);
        }

        if (filter.hasError !== undefined) {
            params.set("hasError", filter.hasError.toString());
        }

        return Axios.get(`${this.basePath}/messages?${params.toString()}`)
            .then(value => {
                const objectList: QueueMessage[] = [];

                value.data.data.forEach((objectJson: object) => {
                    objectList.push(QueueMessage.fromPOJO(objectJson));
                });

                return new PagedResult(value.data.total, objectList);
            });
    }
}

export default QueueService;
